import { BaseEntity } from '../../../../models';
import { CidadeSubRegiaoBairro } from '../../../cidade/bairro';

export class RegiaoCidadeSubRegiaoBairro implements BaseEntity {
    readonly id: number;
    idRegiaoCidadeSubRegiao: number;
    idCidadeSubRegiaoBairro: number;
    cidadeSubRegiaoBairro: CidadeSubRegiaoBairro;

    // Atributos auxiliares
    isChecked: boolean;
}
